module.exports = __webpack_public_path__ + "static/bg-home-mobile-b01e8594af8d413f6400cb98f51e0373.jpg";